import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import '../../styles/header.scss';
import {withExperiments} from 'wix-experiments-react';
import _ from 'lodash';

const Header = ({onExpand, onCollapse, collapsed, chatSettings}) => {

  let button;
  if (collapsed) {
    button = <button className="header-expand"/>;
  } else {
    button = <button className="header-collapse" onClick={onCollapse}/>;
  }
  return (
    <div className="header-wrapper" onClick={() => collapsed ? onExpand() : null}>
      <span className="header-title">{_.get(chatSettings, 'texts.onlineTitle')}</span>
      {button}
    </div>
  );
};

Header.propTypes = {
  onCollapse: PropTypes.func,
  onExpand: PropTypes.func,
  collapsed: PropTypes.bool,
  lookAndFeel: PropTypes.object,
  experiments: PropTypes.object,
  chatSettings: PropTypes.object
};

function mapStateToProps(state) {
  return {
    lookAndFeel: state.lookAndFeel,
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./chat-app/components/Header/Header.js